<template>
  <div class="step-three">
    <div class="container">
      <div class="step-row">
        <el-steps
          :active="activeStep"
          simple
          finish-status="success"
          style="background-color: #fff"
        >
          <el-step title="01.填写主体信息"></el-step>
          <el-step title="02.填写店铺信息"></el-step>
          <el-step title="03.资质审核"></el-step>
          <el-step title="04.账户验证"></el-step>
        </el-steps>
      </div>

      <div class="tips">
        <p class="tip-text">
          <i class="el-icon-time"></i>
          <span>最新资质提交资质审核中</span>
        </p>
        <p class="time">
          提交时间：{{ formatDate(submitTime, "YYYY-MM-DD HH:mm:ss") }}
        </p>
        <p class="t">平台将在1-3个工作日内进行审核，请及时查看审核结果</p>

        <el-popover placement="bottom-start" width="212" trigger="click">
          <div>
            <div class="dy">
              <el-image
                class="code-img"
                :src="require('@/assets/images/simulation/douyin-account.png')"
                fit="contain"
              ></el-image>
              <p class="info mt">抖音电商平台治理小管家</p>
              <div>
                <el-image
                  class="icon-img"
                  :src="require('@/assets/images/simulation/icon_dy.png')"
                  fit="contain"
                ></el-image>
                <span class="info">抖音扫一扫关注</span>
              </div>
            </div>
            <div class="wx">
              <el-image
                class="code-img"
                :src="require('@/assets/images/simulation/weixin-account.png')"
                fit="contain"
              ></el-image>
              <p class="info mt">抖音电商商家助手公众号</p>
              <div>
                <el-image
                  class="icon-img"
                  :src="require('@/assets/images/simulation/icon_wx.png')"
                  fit="contain"
                ></el-image>
                <span class="info">微信扫一扫关注</span>
              </div>
            </div>
          </div>
          <p class="rule" slot="reference">
            <i class="el-icon-document"></i><span>了解经营规则</span>
          </p>
        </el-popover>
      </div>

      <div class="main">
        <div class="section">
          <p class="title no-top">营业证件信息</p>
          <div class="s-main">
            <div class="s-item">
              <p class="label">公司名称</p>
              <p class="content">{{ form.companyName }}</p>
            </div>
            <div class="s-item">
              <p class="label">统一社会信用代码</p>
              <p class="content">{{ form.crediCode }}</p>
            </div>
            <div class="s-item">
              <p class="label">营业执照照片</p>
              <el-image
                class="content img"
                :src="form.licenseImg"
                fit="contain"
                :preview-src-list="[form.licenseImg]"
              ></el-image>
            </div>
            <div class="s-item">
              <p class="label">营业期限</p>
              <p class="content">{{ formatDate(form.date, "YYYY-MM-DD") }}</p>
            </div>
            <div class="s-item">
              <p class="label">经营地址</p>
              <p class="content">{{ form.address.join("-") }}</p>
            </div>
            <div class="s-item">
              <p class="label">主体类型</p>
              <p class="content">{{ form.type == 1 ? "个人" : "企业" }}</p>
            </div>
          </div>
        </div>

        <div class="line"></div>

        <div class="section">
          <p class="title">营业者信息</p>
          <div class="s-main">
            <div class="s-item">
              <p class="label">法定代表人身份归属地</p>
              <p class="content">{{ form.personAddress }}</p>
            </div>
            <div class="s-item">
              <p class="label">法定代表人证件类型</p>
              <p class="content">身份证</p>
            </div>
            <div class="s-item">
              <p class="label">法定代表人身份证头像面</p>
              <el-image
                class="content img"
                :src="form.frontIdCard"
                fit="contain"
                :preview-src-list="[form.frontIdCard]"
              ></el-image>
            </div>
            <div class="s-item">
              <p class="label">法定代表人身份证国徽面</p>
              <el-image
                class="content img"
                :src="form.backIdCard"
                fit="contain"
                :preview-src-list="[form.backIdCard]"
              ></el-image>
            </div>
            <div class="s-item">
              <p class="label">法定代表人姓名</p>
              <p class="content">{{ encryptionInfo(form.realName) }}</p>
            </div>
            <div class="s-item">
              <p class="label">法定代表人证件号码</p>
              <p class="content">{{ encryptionInfo(form.idNumber) }}</p>
            </div>
            <div class="s-item">
              <p class="label">证件有效期</p>
              <p class="content">
                {{ formatDate(form.idCardDate, "YYYY-MM-DD") }}
              </p>
            </div>
          </div>
        </div>

        <div class="line"></div>

        <div class="section">
          <p class="title">店铺基本信息</p>
          <div class="s-main">
            <div class="s-item">
              <p class="label">店铺ID</p>
              <p class="content">2788809482449671</p>
            </div>
            <div class="s-item">
              <p class="label">店铺类型</p>
              <p class="content">{{ formatter(form.shopType) }}</p>
            </div>
            <div class="s-item">
              <p class="label">店铺名称</p>
              <p class="content">{{ form.shopName }}</p>
            </div>
            <div class="s-item">
              <p class="label">店铺logo</p>
              <el-image
                class="content img"
                :src="form.logo"
                fit="contain"
                :preview-src-list="[form.logo]"
              ></el-image>
            </div>
          </div>
        </div>

        <div class="line"></div>

        <div class="section">
          <p class="title">经营类目</p>
          <div class="s-main">
            <div class="s-item">
              <p class="label">经营类目</p>
              <p class="content">
                <span
                  class="category-item"
                  v-for="(item, idx) in form.category"
                  :key="idx"
                  >{{ item.join("/") }}</span
                >
              </p>
            </div>
            <div class="s-item">
              <p class="label">行业资质</p>
              <p class="content">无</p>
            </div>
          </div>
        </div>

        <div class="line"></div>

        <div class="section">
          <p class="title">店铺管理人信息</p>
          <div class="s-main">
            <div class="s-item">
              <p class="label">管理人姓名</p>
              <p class="content">{{ encryptionInfo(form.administrator) }}</p>
            </div>
            <div class="s-item">
              <p class="label">管理人手机号</p>
              <p class="content">
                {{ encryptionInfo(form.administratorMobile) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/utils/index";

export default {
  data() {
    return {
      formatDate,
      activeStep: 2,
      form: {},
      submitTime: Date,
    };
  },
  created() {
    this.form = JSON.parse(this.$route.query.data);
    this.submitTime = this.$route.query.time;
    this.$message.success("10秒后将通过审核，进入下一步");
    setInterval(() => {
      this.$router.push({
        path: "/simulation/doudian/step/stepFour",
        query: {
          data: this.$route.query.data,
        },
      });
    }, 10000);
  },
  methods: {
    encryptionInfo(val) {
      let newVal;
      //身份证
      if (val.length === 18 || val.length === 15) {
        newVal = val.replace(/^(\d{5})\d+(\d{3})$/, "$1******$2");
      } else if (val.length === 11) {
        // 手机号
        newVal = val.replace(/^(\d{3})\d+(\d{2})$/, "$1****$2");
      } else {
        // 姓名
        newVal = val.substring(0, 1) + "***";
      }
      return newVal;
    },
    formatter(shopType) {
      if (shopType == "1") {
        return "普通店";
      } else if (shopType == "2") {
        return "专营店";
      } else if (shopType == "3") {
        return "专卖店";
      } else {
        return "旗舰店";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.step-three {
  position: relative;
  padding: 16px 0;
  width: 100%;
  min-height: 100vh;
  background: rgb(246, 246, 250);

  .step-row {
    padding: 13px 40px;
    background-color: #fff;
    margin-bottom: 16px;
    border-radius: 4px;
    ::v-deep .el-step.is-simple {
      .el-step__title {
        font-size: 14px;
      }
      .el-step__arrow {
        position: relative;
        &::before {
          display: none;
        }
        &::after {
          position: absolute;
          top: 8px;
          left: 6px;
          display: block;
          width: 90%;
          content: "";
          height: 4px;
          background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIyIiBoZWlnaHQ9IjQiIHJ4PSIxIiBmaWxsPSIjZWRlZWYwIi8+PC9zdmc+)
            repeat-x;
          transform: none;
        }
      }
    }
  }
  .tips {
    position: relative;
    margin: 16px 0;
    padding: 24px;
    border-radius: 4px;
    background-color: #fff;
    text-align: left;
    .tip-text {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #12141a;
      margin-bottom: 4px;
      .el-icon-time {
        margin-right: 8px;
        color: #1966ff;
      }
    }
    .time {
      padding-left: 24px;
      font-size: 12px;
      line-height: 16px;
      color: #85878a;
      opacity: 0.8;
    }
    .t {
      margin-left: 24px;
      margin-top: 4px;
      font-size: 12px;
      line-height: 16px;
      color: #55585c;
    }
    .rule {
      position: absolute;
      top: 24px;
      right: 24px;
      color: #898b8f;
      cursor: pointer;
      &:hover {
        color: #1966ff;
      }
      span {
        margin-left: 3px;
      }
    }
  }
  .main {
    padding: 24px 24px 8px;
    border-radius: 4px;
    background-color: #fff;
    text-align: left;
    .section {
      .title {
        margin: 24px 0;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #12141a;
        &.no-top {
          margin-top: 0px;
        }
      }
      .s-main {
        margin-left: 40px;
        margin-bottom: 16px;
        .s-item {
          margin-bottom: 8px;
          padding: 8px 0;
          font-size: 14px;
          line-height: 20px;
          .label,
          .content {
            display: inline-block;
            vertical-align: top;
            &.label {
              width: 170px;
              color: rgb(85, 88, 92);
            }
            &.img {
              width: 88px;
              height: 88px;
              background: #ddd;
            }
            .category-item {
              // display: inline-block;
              color: rgb(18, 20, 26);
              border: 1px solid transparent;
              background: rgb(243, 244, 245);
              margin: 0px 8px 8px 0px;
              padding: 4px 8px;
            }
          }
        }
      }
    }

    .line {
      width: 100%;
      height: 1px;
      background-color: #edeef0;
    }
  }
}
</style>
<style lang="less">
.dy,
.wx {
  display: inline-block;
  width: 50%;
  text-align: center;
  .code-img {
    width: 80px;
    height: 80px;
  }
  .info {
    color: #898b8f;
    font-size: 12px;
    line-height: 16px;
    .mt {
      margin-top: 4px;
    }
  }
  .icon-img {
    display: inline-block;
    margin-right: 3px;
    width: 12px;
    height: 12px;
    vertical-align: middle;
  }
}
</style>